import React, { ChangeEvent, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import { useStore } from "../../contexts/StoreProvider";
import UserType from "../../constants/userType.constant";
import { getClientId, getUserType } from "../../helpers/localStorages.helper";
import MainTabsView from "../../modules/TabControl/TabsView";

import { Col, Dropdown, ListGroup, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import "./Header.scss";
import DateRangeFilter from "../../modules/Filter/Filter";
import {
  accessPermissionPermitted,
  isOperationPermitted,
  isUserPermitted,
} from "../../helpers/routesFunctions.helper";
import { IOption } from "../../models/ICommon";
import { observer } from "mobx-react";
import { formatMessage } from "../../translations/formatMessage";
import { ModuleEnum } from "../../constants/enums/ModuleEnum";
import { ModuleName } from "../../constants/moduleName.constant";
import Select, { GroupBase, SingleValue } from "react-select";
import { ActionMeta, InputActionMeta } from "react-select";

interface IProps {
  filterButton?: React.JSX.Element;
  moduleNameString: string;
  moduleName: string;
  setIsFullScreen?: React.Dispatch<React.SetStateAction<boolean>>;
  addHandler?: (row: { Id: number }) => void;
  exportCSVHandler?: () => void;
  filterHandler?: () => void;
  isAdd: boolean;
  isSideView?: boolean;
  sideViewHandler?: () => void;
  isAddSetting?: boolean;
  addSettingHandler?: () => void;
  addButtonTitle?: string;
  isFullView: boolean;
  isDownload: boolean;
  isRefresh: boolean;
  isFilter: boolean;
  isDateFilter: boolean;
  switchButton?: () => React.JSX.Element;
  showClientSelectHandler?: boolean;
  clientSelectHandler?: (e: {
    label: string;
    value: number;
    key: number;
  }) => void;
  setIsGlobalFilterChanged?: React.Dispatch<React.SetStateAction<boolean>>;
  dateFilterHandler?: (values: { startDate: Date; endDate: Date }) => void;
  isGlobalFilterChanged?: boolean;
  dateFilter?: { startDate: Date; endDate: Date };
  resetFilterHandler?: () => void;
  refreshClickHandler?: () => void;
  isFilterActive?: boolean;
  isImport: boolean;
  importCSVHandler?: () => void;
  isMissing: boolean;
  missingTicketHandler?: () => void;
  isSelectAssetId: boolean;
  selectAssetIdHandler?: () => void;
  isDeleteAlarm: boolean;
  deleteFilteredAlarmSubmitHandler?: () => void;
  deleteAllAlarmSubmitHandler?: () => void;
  deleteSelectedAlarmSubmitHandler?: () => void;
  alarmSelected?: number[];
  multipleDeleteModule?: string;
  isFailedAssets?: boolean;
  failedAssetsHandler?: () => void;
}

const customStyles = {
  option: (provided: any, state: { isSelected: any }) => ({
    ...provided,
    borderBottom: "1px dotted #fc8f0b",
    color: state.isSelected ? "" : "white",
    background: "#fc8f0b",
    padding: 5,
    margin: 0,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    width: 150,
  }),
  singleValue: (provided: any, state: { isDisabled: any }) => {
    // const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";
    return { ...provided, transition };
  },
  menuList: (provided: any, state: any) => ({
    ...provided,
    paddingTop: 0,
    paddingBottom: 0,
  }),
};

const SubHeader = (props: IProps) => {
  const { authStore, preferencesStore } = useStore();
  const {
    moduleName,
    setIsFullScreen,
    addHandler,
    isAdd,
    isSideView,
    sideViewHandler,
    addButtonTitle,
    isFullView,
    isDownload,
    isRefresh,
    refreshClickHandler,
    isFilter,
    isDateFilter,
    exportCSVHandler,
    filterHandler,
    switchButton,
    clientSelectHandler,
    showClientSelectHandler,
    isFilterActive,
    resetFilterHandler,
    isAddSetting,
    addSettingHandler,
    importCSVHandler,
    isImport,
    isMissing,
    missingTicketHandler,
    isSelectAssetId,
    selectAssetIdHandler,
    isDeleteAlarm,
    deleteFilteredAlarmSubmitHandler,
    deleteAllAlarmSubmitHandler,
    deleteSelectedAlarmSubmitHandler,
    alarmSelected,
    multipleDeleteModule,
    isFailedAssets,
    failedAssetsHandler,
  } = props;
  const { userType } = authStore;
  const {
    allAvailableClientsOptions,
    selectedClientId,
    GetAllClientsService,
    setSelectedClientId,
    setAmountDecimal,
    clientList,
  } = preferencesStore;
  const userIsSystemAdmin =
    userType === UserType.SuperAdmin || getUserType() === UserType.SuperAdmin;
  const [dropdownInputValue, setDropdownInputValue] = useState<string>("");

  useEffect(() => {
    if (getUserType() == UserType.SuperAdmin && showClientSelectHandler) {
      GetAllClientsService();
    } else {
      let clientId = getClientId();
      setSelectedClientId(clientId ? parseInt(clientId) : -1);
    }
  }, []);

  return (
    <section>
      <Container fluid className="position-absolute bottom-0 mb-2">
        <Row>
          <div className=" col-xxl-6 col-lg-3 col-md-3 col-sm-3">
            <h2 className="align-self-center text-white fw-bold">
              <FormattedMessage id={props.moduleNameString} />
            </h2>
          </div>
          <div className="d-flex justify-content-end col-xxl-6 col-lg-9 col-md-9 col-sm-9">
            {isDateFilter &&
              props.setIsGlobalFilterChanged &&
              props.dateFilterHandler &&
              props.dateFilter && (
                <DateRangeFilter
                  dateFilterHandler={props.dateFilterHandler}
                  setIsGlobalFilterChanged={props.setIsGlobalFilterChanged}
                  isGlobalFilterChanged={props.isGlobalFilterChanged ?? false}
                  dateFilter={props.dateFilter}
                />
              )}

            <ListGroup horizontal>
              {allAvailableClientsOptions.length > 0 &&
                clientSelectHandler !== undefined &&
                UserType.SuperAdmin == getUserType() &&
                showClientSelectHandler && (
                  <>
                    <Select
                      className="custom-dropdown custom-select"
                      classNamePrefix="filter"
                      styles={{
                        ...customStyles,
                        control: (provided, state) => ({
                          ...provided,
                          paddingRight: state.menuIsOpen ? "10px" : "2.5rem",
                        }),
                      }}
                      isSearchable={false}
                      value={allAvailableClientsOptions
                        .filter((e) => e.Id === selectedClientId)
                        .map((e) => ({
                          label: e.Name,
                          value: e.Id,
                          key: e.Id,
                        }))}
                      options={allAvailableClientsOptions.map((option) => ({
                        label: formatMessage(option.Name),
                        value: option.Id,
                        key: option.Id,
                      }))}
                      onChange={(
                        newValue: SingleValue<{
                          label: string;
                          value: number;
                          key: number;
                        }>
                      ) => {
                        setDropdownInputValue(newValue?.label ?? "");
                        clientSelectHandler &&
                          clientSelectHandler(
                            newValue ?? {
                              label: "please_select",
                              value: -1,
                              key: -1,
                            }
                          );
                      }}
                    />

                    {/* <select
                      className="groupSelect"
                      value={selectedClientId}
                      onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                        clientSelectHandler && clientSelectHandler(e);
                        // resetFilterHandler && resetFilterHandler();
                      }}
                    >
                      {allAvailableClientOptions.map(
                        (data: IOption, i: number) => (
                          <option key={i} value={data.Id}>
                            {i == 0 ? formatMessage(data.Name) : data.Name}
                          </option>
                        )
                      )}
                    </select> */}
                  </>
                )}

              {isAddSetting && isOperationPermitted(ModuleName.Customer) && (
                <ListGroup.Item
                  onClick={() => {
                    addSettingHandler && addSettingHandler();
                  }}
                  className="border-0 bg-transparent px-2 pt-0"
                  title="AddSetting"
                >
                  <div className="btn btn-lg text-white addbutton maroon circle-icon-m">
                    <svg
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      height="18"
                      width="18"
                      fill="#fff"
                      x="0px"
                      y="0px"
                      viewBox="0 0 37.622 37.622"
                    >
                      <g>
                        <path
                          d="M37.306,27.558c-1.339-2.418-7.203-3.958-12.381-4.25c-0.468-0.501-0.943-1.028-1.43-1.582
		c-4.45-5.088-6.252-12.482-6.925-16.399c-0.08-0.83-0.168-1.52-0.242-2.034c-0.06-0.409-0.186-1.262-1.073-1.262
		c-0.284,0-0.558,0.122-0.753,0.339c-0.316,0.361-0.269,0.749-0.213,1.197c0.063,0.514,0.158,1.202,0.293,1.987
		c0.379,3.977,0.558,11.549-2.503,17.564c-0.319,0.627-0.637,1.229-0.953,1.803c-5.728,1.666-10.35,4.637-11.027,7.101
		c-0.245,0.892-0.032,1.747,0.601,2.409c0.737,0.77,1.607,1.16,2.586,1.16c2.71,0,5.799-3.018,9.181-8.967
		c1.506-0.396,3.001-0.672,4.446-0.818c0.563-0.057,1.474-0.176,2.034-0.262c1.543-0.238,3.289-0.334,5.083-0.275
		c4.152,4.316,7.547,6.504,10.091,6.504c1.366-0.001,2.497-0.667,3.183-1.875C37.726,29.15,37.728,28.318,37.306,27.558z
		 M3.285,33.591c-0.424,0-0.786-0.172-1.141-0.543c-0.145-0.151-0.177-0.281-0.117-0.495c0.349-1.269,3.281-3.444,7.566-5.023
		C7.172,31.35,4.855,33.591,3.285,33.591z M18.64,23.57c-0.532,0.082-1.396,0.194-1.93,0.25c-0.971,0.096-1.969,0.249-2.976,0.455
		c0.042-0.082,0.084-0.165,0.126-0.248c1.501-2.949,2.431-6.485,2.775-10.538c1.377,3.854,3.173,7.06,5.354,9.554
		c0.064,0.074,0.131,0.149,0.195,0.225C20.925,23.298,19.737,23.401,18.64,23.57z M35.56,28.916
		c-0.332,0.588-0.804,0.861-1.481,0.861h-0.001c-1.59,0-4.035-1.505-6.962-4.265c4.53,0.569,7.847,1.94,8.442,3.015
		C35.644,28.683,35.644,28.766,35.56,28.916z"
                        />
                      </g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>{" "}
                    <span className="text-hidden-m">
                      {" "}
                      <FormattedMessage id="label_setting_edit" />
                    </span>
                  </div>
                </ListGroup.Item>
              )}

              {isRefresh && (
                <ListGroup.Item
                  className="border-0 bg-transparent px-2 pt-0"
                  onClick={() => {
                    refreshClickHandler && refreshClickHandler();
                  }}
                  title="Refresh"
                >
                  <div className="circle-icon purple">
                    <svg
                      enableBackground="new 0 0 512.449 512.449"
                      height="20"
                      fill="#fff"
                      viewBox="0 0 512.449 512.449"
                      width="20"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path d="m152.083 286.805c7.109-8.155 1.318-20.888-9.501-20.888h-32.392c-.211-3.205-.329-6.435-.329-9.692 0-80.706 65.658-146.364 146.363-146.364 38.784 0 74.087 15.168 100.304 39.877l45.676-53.435c-39.984-36.577-91.44-56.612-145.98-56.612-57.838 0-112.214 22.524-153.112 63.421-40.897 40.898-63.421 95.274-63.421 153.112 0 3.243.081 6.473.222 9.692h-27.284c-10.819 0-16.611 12.733-9.501 20.888l61.549 70.6 12.928 14.829 46.416-53.242z" />
                        <path d="m509.321 245.614-45.907-52.658-28.57-32.771-40.791 46.789-33.686 38.64c-7.109 8.155-1.318 20.888 9.501 20.888h32.354c-5.293 75.928-68.748 136.086-145.997 136.086-33.721 0-64.811-11.469-89.586-30.703l-45.679 53.439c38.267 30.731 85.479 47.434 135.266 47.434 57.838 0 112.214-22.523 153.112-63.421 38.466-38.466 60.672-88.856 63.177-142.834h27.306c10.818-.001 16.609-12.734 9.5-20.889z" />
                      </g>
                    </svg>
                  </div>{" "}
                </ListGroup.Item>
              )}

              {isAdd &&
                (props.moduleName === ModuleName.VehicleManagement
                  ? accessPermissionPermitted(props.moduleName, "add")
                  : isOperationPermitted(props.moduleName)) && (
                  <ListGroup.Item
                    onClick={() => {
                      addHandler && addHandler({ Id: -1 });
                    }}
                    className="border-0 bg-transparent px-2 pt-0"
                    title="Add"
                  >
                    <div className="btn btn-lg text-white addbutton circle-icon-m">
                      <svg
                        enableBackground="new 0 0 512 512"
                        fill="#fff"
                        height="18"
                        width="18"
                        viewBox="0 0 512 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g>
                          <path d="m467 211h-166v-166c0-24.853-20.147-45-45-45s-45 20.147-45 45v166h-166c-24.853 0-45 20.147-45 45s20.147 45 45 45h166v166c0 24.853 20.147 45 45 45s45-20.147 45-45v-166h166c24.853 0 45-20.147 45-45s-20.147-45-45-45z" />
                        </g>
                      </svg>{" "}
                      <span className="text-hidden-m">
                        <FormattedMessage
                          id={addButtonTitle ? addButtonTitle : "add"}
                        />
                      </span>
                    </div>
                  </ListGroup.Item>
                )}
              {isSideView && props.moduleName == ModuleName.Reports && (
                <ListGroup.Item
                  onClick={() => {
                    sideViewHandler && sideViewHandler();
                  }}
                  className="border-0 bg-transparent px-2 pt-0"
                  title="Downloads"
                >
                  <div className="btn btn-lg text-white addbutton ">
                    <svg
                      version="1.1"
                      x="0px"
                      y="0px"
                      fill="#fff"
                      height="15"
                      width="15"
                      viewBox="0 0 512 512"
                    >
                      <g>
                        <g>
                          <path
                            d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64
			c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472
			c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z" />
                        </g>
                      </g>
                    </svg>{" "}
                    <FormattedMessage id="downloads" />
                  </div>
                </ListGroup.Item>
              )}
              {switchButton && switchButton()}

              {isFilter && (
                <>
                  {isFilterActive && (
                    <ListGroup.Item
                      className="border-0 bg-transparent px-2 pt-0"
                      onClick={() => {
                        resetFilterHandler && resetFilterHandler();
                      }}
                      title="Reset Filter"
                    >
                      <div className="filter">
                        <div className="circle-icon purple">
                          <svg
                            id="Capa_1"
                            enableBackground="new 0 0 512.004 512.004"
                            fill="#fff"
                            className="clearfilter"
                            viewBox="0 0 512.004 512.004"
                            height="25"
                            width="25"
                          >
                            <g>
                              <path d="m361.183 0c-54.059 0-99.836 36.049-114.505 85.331h-192.948c-18.024 0-28.614 20.339-18.285 35.119.16.231-5.363-7.31 129.747 177.039 2.714 3.951 4.148 8.57 4.148 13.367v177.688c0 19.435 22.224 30.24 37.473 18.754l57.593-43.518c8.614-6.415 13.754-16.655 13.754-27.409v-125.515c0-4.798 1.435-9.417 4.149-13.369l46.497-63.451c76.139 21.439 151.81-36.022 151.81-114.791.001-65.752-53.577-119.245-119.433-119.245zm-103.192 279.919c-5.835 7.968-9.831 19.1-9.831 30.938 0 136.483.734 127.081-1.68 128.869-1.91 1.421 10.835-8.188-47.14 35.618v-164.488c0-11.012-3.327-21.608-9.622-30.646-.169-.242 4.923 6.71-120.835-164.88h172.938c-1.457 44.852 22.126 84.961 58.678 106.581zm103.192-71.428c-49.314 0-89.434-40.035-89.434-89.246 0-49.21 40.12-89.245 89.434-89.245 49.313 0 89.433 40.035 89.433 89.245.001 49.211-40.119 89.246-89.433 89.246z" />
                              <path d="m400.201 80.298c-5.854-5.864-15.35-5.872-21.213-.02l-17.805 17.773-17.805-17.773c-5.863-5.853-15.361-5.846-21.213.02-5.853 5.862-5.844 15.36.019 21.213l17.767 17.735-17.767 17.735c-5.863 5.853-5.872 15.351-.019 21.213 5.833 5.844 15.331 5.891 21.213.02l17.805-17.773 17.805 17.773c5.845 5.834 15.343 5.862 21.213-.02 5.853-5.862 5.844-15.36-.019-21.213l-17.767-17.735 17.767-17.735c5.863-5.853 5.872-15.351.019-21.213z" />
                            </g>
                          </svg>
                        </div>
                      </div>
                    </ListGroup.Item>
                  )}
                  <ListGroup.Item
                    className="border-0 bg-transparent px-1 pt-0"
                    onClick={() => {
                      filterHandler && filterHandler();
                    }}
                    title="Filter"
                  >
                    <div className="filter">
                      <div className="circle-icon  blue">
                        <svg
                          fill="#fff"
                          height="25"
                          width="25"
                          viewBox="0 0 32 32"
                        >
                          <path
                            clipRule="evenodd"
                            d="m5.26238 4.5c-.00016 0 .00016 0 0 0h21.47502c.4849.00015.9598.14134 1.3659.40635s.7264.64242.9218 1.08623.2575.93488.1788 1.41337c-.0786.47733-.2939.92158-.6199 1.27892-.0008.00088-.0016.00176-.0024.00263l-8.0817 8.8936v6.876c.0024.4158-.0994.8255-.2963 1.1918-.1964.3657-.4812.6762-.8283.9036l-4.0003 2.6627c-.3751.2471-.8099.3885-1.2586.4094-.4487.021-.8947-.0793-1.2912-.2904-.3965-.211-.7288-.525-.962-.9089-.2332-.3838-.3587-.8235-.3632-1.2726l-.0001-.0152v-9.5564l-8.08175-8.8936c-.0007-.00077-.0014-.00154-.0021-.0023-.32615-.3574-.5416-.80178-.62017-1.27925-.07875-.47849-.01663-.96955.17878-1.41337.19541-.44381.51568-.82122.92179-1.08623.40546-.26459.87902-.40575 1.36315-.40635m1.13306 3 7.44944 8.1978c.4264.4611.6616 1.0671.6578 1.6953v8.8008l3-1.9969v-6.8039c-.0038-.6282.2314-1.2342.6578-1.6953l7.4494-8.1978z"
                            fillRule="evenodd"
                          />
                        </svg>
                      </div>
                    </div>
                  </ListGroup.Item>
                </>
              )}
              {isFullView && (
                <ListGroup.Item
                  onClick={() => {
                    setIsFullScreen &&
                      setIsFullScreen((isFullScreen) => !isFullScreen);
                  }}
                  className="border-0 bg-transparent px-2 pt-0 d-none d-sm-block"
                  title="Fullscreen"
                >
                  <div className="circle-icon green">
                    <svg
                      height="22"
                      fill="#fff"
                      viewBox="0 0 24 24"
                      width="22"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        clipRule="evenodd"
                        d="m12.75 4c0 .69036.5596 1.25 1.25 1.25h2.9822l-3.8661 3.86612c-.4881.48815-.4881 1.27958 0 1.76778.4882.4881 1.2796.4881 1.7678 0l3.8661-3.86613v2.98223c0 .6904.5596 1.25 1.25 1.25s1.25-.5596 1.25-1.25v-6c0-.69036-.5596-1.25-1.25-1.25h-6c-.6904 0-1.25.55964-1.25 1.25zm-7.5 10c0-.6904-.55964-1.25-1.25-1.25s-1.25.5596-1.25 1.25v6c0 .6904.55964 1.25 1.25 1.25h6c.6904 0 1.25-.5596 1.25-1.25s-.5596-1.25-1.25-1.25h-2.98223l3.86613-3.8661c.4881-.4882.4881-1.2796 0-1.7678-.4882-.4881-1.27963-.4881-1.76778 0l-3.86612 3.8661z"
                        fillRule="evenodd"
                      />
                    </svg>
                  </div>
                </ListGroup.Item>
              )}

              {/* {moduleName !== ModuleEnum.Dashboard && <ListGroup.Item className="border-0 bg-transparent px-2 pt-0">
                  <div className="circle-icon yellow">

                    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#fff"
                      height="20"
                      width="20" x="0px" y="0px"
                      viewBox="0 0 512 512">
                      <g>
                        <g>
                          <path d="M129.4,150.6c2.6,5.7,8.3,9.4,14.6,9.4h64v208c0,8.8,7.2,16,16,16h64c8.8,0,16-7.2,16-16V160h64c6.3,0,12-3.7,14.6-9.4
			c2.6-5.7,1.6-12.4-2.5-17.2L268,5.5C265,2,260.6,0,256,0c-4.6,0-9,2-12,5.5l-112,128C127.8,138.2,126.8,144.9,129.4,150.6z"/>
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M432,352v96H80v-96H16v128c0,17.7,14.3,32,32,32h416c17.7,0,32-14.3,32-32V352H432z" />
                        </g>
                      </g>
                    </svg>

                  </div>
                </ListGroup.Item>} */}

              {isDownload && (
                <ListGroup.Item
                  className="border-0 bg-transparent px-1 pt-0"
                  onClick={() => {
                    exportCSVHandler && exportCSVHandler();
                  }}
                  title="Export CSV"
                >
                  <div className="circle-icon green">
                    <svg
                      version="1.1"
                      x="0px"
                      y="0px"
                      fill="#fff"
                      height="20"
                      width="20"
                      viewBox="0 0 512 512"
                    >
                      <g>
                        <g>
                          <path
                            d="M382.56,233.376C379.968,227.648,374.272,224,368,224h-64V16c0-8.832-7.168-16-16-16h-64c-8.832,0-16,7.168-16,16v208h-64
			c-6.272,0-11.968,3.68-14.56,9.376c-2.624,5.728-1.6,12.416,2.528,17.152l112,128c3.04,3.488,7.424,5.472,12.032,5.472
			c4.608,0,8.992-2.016,12.032-5.472l112-128C384.192,245.824,385.152,239.104,382.56,233.376z"
                          />
                        </g>
                      </g>
                      <g>
                        <g>
                          <path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z" />
                        </g>
                      </g>
                    </svg>
                  </div>{" "}
                </ListGroup.Item>
              )}

              {isImport &&
                (props.moduleName === ModuleName.VehicleManagement
                  ? accessPermissionPermitted(props.moduleName, "add")
                  : isOperationPermitted(props.moduleName)) && (
                  <ListGroup.Item
                    className="border-0 bg-transparent px-2 pt-0"
                    onClick={() => {
                      importCSVHandler && importCSVHandler();
                    }}
                    title="Import CSV"
                  >
                    <div className="circle-icon yellow">
                      <svg
                        version="1.1"
                        id="Capa_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        fill="#fff"
                        height="20"
                        width="20"
                        viewBox="0 0 512 512"
                      >
                        <g>
                          <g>
                            <path
                              d="M380.032,133.472l-112-128C264.992,2.016,260.608,0,256,0c-4.608,0-8.992,2.016-12.032,5.472l-112,128
			c-4.128,4.736-5.152,11.424-2.528,17.152C132.032,156.32,137.728,160,144,160h64v208c0,8.832,7.168,16,16,16h64
			c8.832,0,16-7.168,16-16V160h64c6.272,0,11.968-3.648,14.56-9.376C385.152,144.896,384.192,138.176,380.032,133.472z"
                            />
                          </g>
                        </g>
                        <g>
                          <g>
                            <path d="M432,352v96H80v-96H16v128c0,17.696,14.336,32,32,32h416c17.696,0,32-14.304,32-32V352H432z" />
                          </g>
                        </g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                        <g></g>
                      </svg>
                    </div>{" "}
                  </ListGroup.Item>
                )}
              {isMissing &&
                isUserPermitted() &&
                isOperationPermitted(props.moduleName) && (
                  <ListGroup.Item
                    className="border-0 bg-transparent px-2 pt-0"
                    onClick={() => {
                      missingTicketHandler && missingTicketHandler();
                    }}
                    title="Find Missing Tickets"
                  >
                    <div className="circle-icon yellow">
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M3 7a2 2 0 012-2h6v4c-1 0-2 .9-2 2s1 2 2 2v4H5a2 2 0 01-2-2V7z"
                          stroke="white"
                          stroke-width="2"
                          fill="none"
                        />
                        <path
                          d="M21 17a2 2 0 01-2 2h-6v-4c1 0 2-.9 2-2s-1-2-2-2V7h6a2 2 0 012 2v8z"
                          stroke="white"
                          stroke-width="2"
                          fill="none"
                        />
                        <path
                          d="M12 6l-1 2 1 2-1 2 1 2-1 2"
                          stroke="white"
                          stroke-width="2"
                          fill="none"
                        />
                      </svg>
                    </div>{" "}
                  </ListGroup.Item>
                )}

              {isSelectAssetId &&
                isUserPermitted() &&
                isOperationPermitted(props.moduleName) && (
                  <ListGroup.Item
                    className="border-0 bg-transparent px-1 pt-0"
                    title="Downlink Asset"
                    onClick={() => {
                      selectAssetIdHandler && selectAssetIdHandler();
                    }}
                  >
                    <div className="circle-icon yellow">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        id="Layer_3"
                        fill="#fff"
                        height="22"
                        width="22"
                        data-name="Layer 3"
                        viewBox="0 0 32 32"
                      >
                        <path d="M27.44,10H23V5.448A4.452,4.452,0,0,0,18.553,1H5.447A4.452,4.452,0,0,0,1,5.448v21.1A4.452,4.452,0,0,0,5.447,31H18.553A4.452,4.452,0,0,0,23,26.552V22h4.44A2.562,2.562,0,0,0,30,19.44V12.56A2.562,2.562,0,0,0,27.44,10Zm-1,2L22,15.7,17.562,12ZM21,26.552A2.45,2.45,0,0,1,18.553,29H5.447A2.45,2.45,0,0,1,3,26.552V5.448A2.45,2.45,0,0,1,5.447,3H18.553A2.45,2.45,0,0,1,21,5.448V10H16.56A2.562,2.562,0,0,0,14,12.56v6.88A2.562,2.562,0,0,0,16.56,22H21ZM27.44,20H16.56a.56.56,0,0,1-.56-.56V13.3l5.359,4.466a1,1,0,0,0,1.282,0L28,13.3V19.44A.56.56,0,0,1,27.44,20Z" />
                        <path d="M15,5a1,1,0,0,0-1-1H10a1,1,0,0,0,0,2h4A1,1,0,0,0,15,5Z" />
                      </svg>
                    </div>{" "}
                  </ListGroup.Item>
                )}

              {isDeleteAlarm && isOperationPermitted(props.moduleName) && (
                <ListGroup.Item
                  className="border-0 bg-transparent px-1 pt-0 deleteDropdownArrow"
                  title={`Delete ${multipleDeleteModule}`}
                >
                  <Dropdown className="border-0 p-0">
                    <Dropdown.Toggle
                      variant=""
                      id="dropdown-basic"
                      className="shadow-none profile-dropdown p-0 m-0"
                    >
                      <div className="circle-icon badge-red ">
                        <svg
                          version="1.1"
                          x="0px"
                          y="0px"
                          width="20"
                          height="20"
                          viewBox="0 0 512 512"
                          fill="#fff"
                        >
                          <g>
                            <g>
                              <path
                                d="M62.205,150l26.569,320.735C90.678,493.865,110.38,512,133.598,512h244.805c23.218,0,42.92-18.135,44.824-41.265
    L449.795,150H62.205z M180.986,452c-7.852,0-14.458-6.108-14.956-14.063l-15-242c-0.513-8.276,5.771-15.395,14.033-15.908
    c8.569-0.601,15.381,5.757,15.908,14.033l15,242C196.502,444.632,189.721,452,180.986,452z M271,437c0,8.291-6.709,15-15,15
    c-8.291,0-15-6.709-15-15V195c0-8.291,6.709-15,15-15s15,6.709,15,15V437z M360.97,195.938l-15,242
    c-0.493,7.874-7.056,14.436-15.908,14.033c-8.262-0.513-14.546-7.632-14.033-15.908l15-242
    c0.513-8.276,7.764-14.297,15.908-14.033C355.199,180.543,361.483,187.662,360.97,195.938z"
                              />
                            </g>
                          </g>
                          <g>
                            <g>
                              <path
                                d="M451,60h-90V45c0-24.814-20.186-45-45-45H196c-24.814,0-45,20.186-45,45v15H61c-16.569,0-30,13.431-30,30
    c0,16.567,13.431,30,30,30c137.966,0,252.039,0,390,0c16.569,0,30-13.433,30-30C481,73.431,467.569,60,451,60z M331,60H181V45
    c0-8.276,6.724-15,15-15h120c8.276,0,15,6.724,15,15V60z"
                              />
                            </g>
                          </g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                          <g></g>
                        </svg>
                      </div>{" "}
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="dropdown-menu-end profile-area border-0 p-0 m-0">
                      {userType != UserType.SuperAdmin && (
                        <Dropdown.Item
                          onClick={() =>
                            deleteFilteredAlarmSubmitHandler &&
                            deleteFilteredAlarmSubmitHandler()
                          }
                          className="d-flex align-items-center"
                          disabled={!isFilterActive}
                        >
                          <FormattedMessage
                            id={`Delete Filtered ${multipleDeleteModule}`}
                          />
                        </Dropdown.Item>
                      )}
                      {/* <Dropdown.Item
                      onClick={() => {}}
                      className="language d-flex justify-content-between mt-3"
                    >
                      Language{" "}
                      <small>
                        English
                        <img src={English} alt="english" className="ms-2" />
                      </small>
                    </Dropdown.Item> */}

                      <Dropdown.Item
                        className="d-flex align-items-center"
                        onClick={() => {
                          deleteSelectedAlarmSubmitHandler &&
                            deleteSelectedAlarmSubmitHandler();
                        }}
                        disabled={alarmSelected && !(alarmSelected?.length > 0)}
                      >
                        <FormattedMessage
                          id={`Delete Selected ${multipleDeleteModule}`}
                        />
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => {
                          deleteAllAlarmSubmitHandler &&
                            deleteAllAlarmSubmitHandler();
                        }}
                        className="d-flex flex-row align-items-center"
                        disabled={
                          (alarmSelected && alarmSelected?.length > 0) ||
                          isFilterActive
                        }
                      >
                        <FormattedMessage
                          id={`Delete All ${multipleDeleteModule}`}
                        />
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </ListGroup.Item>
              )}

              {isFailedAssets &&
                isUserPermitted() &&
                isOperationPermitted(props.moduleName) && (
                  <ListGroup.Item
                    className="border-0 bg-transparent px-1 pt-0"
                    title="Downlink Failed Assets"
                    onClick={() => {
                      failedAssetsHandler && failedAssetsHandler();
                    }}
                  >
                    <div className="circle-icon purple">

<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" height="25" width="25" fill="#fff" x="0px" y="0px"
	 viewBox="0 0 512 512">
<g>
	<g>
		<path d="M386.689,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538
			c35.593,0,64.538-28.951,64.538-64.538S422.276,304.403,386.689,304.403z M386.689,401.21c-17.796,0-32.269-14.473-32.269-32.269
			c0-17.796,14.473-32.269,32.269-32.269c17.796,0,32.269,14.473,32.269,32.269C418.958,386.738,404.485,401.21,386.689,401.21z"/>
	</g>
</g>
<g>
	<g>
		<path d="M166.185,304.403c-35.587,0-64.538,28.951-64.538,64.538s28.951,64.538,64.538,64.538s64.538-28.951,64.538-64.538
			S201.772,304.403,166.185,304.403z M166.185,401.21c-17.796,0-32.269-14.473-32.269-32.269c0-17.796,14.473-32.269,32.269-32.269
			c17.791,0,32.269,14.473,32.269,32.269C198.454,386.738,183.981,401.21,166.185,401.21z"/>
	</g>
</g>
<g>
	<g>
		<path d="M430.15,119.675c-2.743-5.448-8.32-8.885-14.419-8.885h-84.975v32.269h75.025l43.934,87.384l28.838-14.5L430.15,119.675z"
			/>
	</g>
</g>
<g>
	<g>
		<rect x="216.202" y="353.345" width="122.084" height="32.269"/>
	</g>
</g>
<g>
	<g>
		<path d="M117.781,353.345H61.849c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h55.933
			c8.912,0,16.134-7.223,16.134-16.134C133.916,360.567,126.693,353.345,117.781,353.345z"/>
	</g>
</g>
<g>
	<g>
		<path d="M508.612,254.709l-31.736-40.874c-3.049-3.937-7.755-6.239-12.741-6.239H346.891V94.655
			c0-8.912-7.223-16.134-16.134-16.134H61.849c-8.912,0-16.134,7.223-16.134,16.134s7.223,16.134,16.134,16.134h252.773v112.941
			c0,8.912,7.223,16.134,16.134,16.134h125.478l23.497,30.268v83.211h-44.639c-8.912,0-16.134,7.223-16.134,16.134
			c0,8.912,7.223,16.134,16.134,16.134h60.773c8.912,0,16.134-7.223,16.135-16.134V264.605
			C512,261.023,510.806,257.538,508.612,254.709z"/>
	</g>
</g>
<g>
	<g>
		<path d="M116.706,271.597H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h74.218
			c8.912,0,16.134-7.223,16.134-16.134C132.84,278.82,125.617,271.597,116.706,271.597z"/>
	</g>
</g>
<g>
	<g>
		<path d="M153.815,208.134H16.134C7.223,208.134,0,215.357,0,224.269s7.223,16.134,16.134,16.134h137.681
			c8.912,0,16.134-7.223,16.134-16.134S162.727,208.134,153.815,208.134z"/>
	</g>
</g>
<g>
	<g>
		<path d="M180.168,144.672H42.487c-8.912,0-16.134,7.223-16.134,16.134c0,8.912,7.223,16.134,16.134,16.134h137.681
			c8.912,0,16.134-7.223,16.134-16.134C196.303,151.895,189.08,144.672,180.168,144.672z"/>
	</g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>


                    </div>{" "}
                  </ListGroup.Item>
                )}

              {/* <ListGroup.Item className="border-0 bg-transparent px-2 pt-0">
                <div className="circle-icon green">
                  <svg
                    enableBackground="new 0 0 512 512"
                    height="18"
                    fill="#fff"
                    viewBox="0 0 512 512"
                    width="18"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g>
                      <path d="m467 211h-166v-166c0-24.853-20.147-45-45-45s-45 20.147-45 45v166h-166c-24.853 0-45 20.147-45 45s20.147 45 45 45h166v166c0 24.853 20.147 45 45 45s45-20.147 45-45v-166h166c24.853 0 45-20.147 45-45s-20.147-45-45-45z" />
                    </g>
                  </svg>
                </div>
              </ListGroup.Item> */}

              {/* <ListGroup.Item className="border-0 pe-1 bg-transparent">
                <svg
                  width="32"
                  height="33"
                  viewBox="0 0 32 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.9993 0.236115C7.16394 0.236115 0 7.3503 0 16.1243C0 24.8984 7.16394 32.0139 15.9993 32.0139C24.8347 32.0139 32 24.8984 32 16.1243C32 7.3503 24.8347 0.236115 15.9993 0.236115ZM19.33 24.8607C18.5065 25.1835 17.8509 25.4283 17.3592 25.5978C16.8689 25.7673 16.2987 25.852 15.6499 25.852C14.653 25.852 13.8768 25.6099 13.3242 25.127C12.7716 24.6441 12.4966 24.0321 12.4966 23.2883C12.4966 22.9991 12.5169 22.7032 12.5575 22.4019C12.5995 22.1006 12.6659 21.7616 12.7567 21.3809L13.7874 17.7653C13.8782 17.4183 13.9567 17.0888 14.019 16.7821C14.0814 16.4727 14.1112 16.1889 14.1112 15.9306C14.1112 15.4706 14.015 15.1478 13.824 14.9662C13.6303 14.7846 13.2659 14.6958 12.7228 14.6958C12.4573 14.6958 12.1837 14.7349 11.9033 14.8169C11.6257 14.9016 11.3846 14.9783 11.1868 15.0536L11.459 13.9399C12.1336 13.6668 12.7797 13.4328 13.396 13.2391C14.0123 13.0427 14.5947 12.9459 15.1433 12.9459C16.1334 12.9459 16.8974 13.1853 17.4351 13.6588C17.9701 14.1336 18.2397 14.751 18.2397 15.5096C18.2397 15.667 18.2207 15.9441 18.1841 16.3395C18.1476 16.7363 18.0785 17.0982 17.9782 17.4304L16.9529 21.0353C16.8689 21.3245 16.7944 21.6553 16.7267 22.0252C16.6603 22.3951 16.6278 22.6776 16.6278 22.8673C16.6278 23.3461 16.7348 23.673 16.9515 23.8465C17.1655 24.02 17.5407 24.1074 18.0717 24.1074C18.3223 24.1074 18.6027 24.0631 18.9196 23.977C19.2339 23.8909 19.4614 23.8142 19.605 23.7483L19.33 24.8607ZM19.1485 10.2288C18.6704 10.67 18.0947 10.8906 17.4215 10.8906C16.7497 10.8906 16.17 10.67 15.6878 10.2288C15.2083 9.78761 14.9658 9.25092 14.9658 8.6241C14.9658 7.99864 15.2097 7.4606 15.6878 7.01537C16.17 6.5688 16.7497 6.34686 17.4215 6.34686C18.0947 6.34686 18.6717 6.5688 19.1485 7.01537C19.6267 7.4606 19.8664 7.99864 19.8664 8.6241C19.8664 9.25226 19.6267 9.78761 19.1485 10.2288Z"
                    fill="#26BF94"
                  />
                </svg>
              </ListGroup.Item>
              <ListGroup.Item className="border-0 pe-1 bg-transparent">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16 0.222221C7.16375 0.222221 0 7.33622 0 16.1111C0 24.886 7.16375 32 16 32C24.8363 32 32 24.886 32 16.1111C32 7.33622 24.8363 0.222221 16 0.222221ZM11.3125 14.827L11.3275 14.8127C11.4299 14.711 11.5514 14.6303 11.6852 14.5753C11.819 14.5202 11.9624 14.4919 12.1072 14.4919C12.252 14.4919 12.3954 14.5202 12.5292 14.5753C12.6629 14.6303 12.7845 14.711 12.8869 14.8127L14.8956 16.8075V8.80098C14.8956 8.65705 14.9242 8.51453 14.9797 8.38157C15.0352 8.24862 15.1166 8.12784 15.2192 8.02615C15.3218 7.92446 15.4435 7.84385 15.5775 7.78894C15.7115 7.73403 15.8551 7.70589 16 7.70614C16.2924 7.70614 16.5728 7.82149 16.7796 8.02681C16.9863 8.23213 17.1025 8.51061 17.1025 8.80098V16.8075L19.1112 14.8127C19.2137 14.7105 19.3354 14.6295 19.4695 14.5742C19.6036 14.5188 19.7473 14.4904 19.8925 14.4904C20.0377 14.4904 20.1814 14.5188 20.3155 14.5742C20.4496 14.6295 20.5713 14.7105 20.6737 14.8127L20.6887 14.827C20.7912 14.9286 20.8724 15.0493 20.9278 15.1822C20.9832 15.315 21.0118 15.4574 21.0118 15.6012C21.0118 15.745 20.9832 15.8874 20.9278 16.0203C20.8724 16.1531 20.7912 16.2738 20.6887 16.3755L16.7825 20.254C16.6802 20.3557 16.5587 20.4363 16.4249 20.4914C16.2912 20.5464 16.1479 20.5747 16.0031 20.5747C15.8584 20.5747 15.715 20.5464 15.5813 20.4914C15.4476 20.4363 15.3261 20.3557 15.2238 20.254L11.3125 16.3755C11.106 16.17 10.99 15.8916 10.99 15.6012C10.99 15.3109 11.106 15.0325 11.3125 14.827ZM24.625 22.6473C24.6149 23.1395 24.4136 23.6087 24.063 23.9568C23.7125 24.3049 23.24 24.5048 22.7444 24.5148H9.25562C8.76022 24.5049 8.28788 24.3051 7.93739 23.9572C7.58689 23.6094 7.38538 23.1405 7.375 22.6485V19.7376C7.375 19.5938 7.40352 19.4515 7.45892 19.3186C7.51433 19.1858 7.59554 19.0651 7.69791 18.9635C7.80029 18.8618 7.92183 18.7811 8.05559 18.7261C8.18935 18.6711 8.33272 18.6428 8.4775 18.6428C8.7699 18.6428 9.05033 18.7581 9.25708 18.9635C9.46384 19.1688 9.58 19.4473 9.58 19.7376V22.3264H22.42V19.7376C22.42 19.4473 22.5362 19.1688 22.7429 18.9635C22.9497 18.7581 23.2301 18.6428 23.5225 18.6428C23.8149 18.6428 24.0953 18.7581 24.3021 18.9635C24.5088 19.1688 24.625 19.4473 24.625 19.7376V22.6473Z"
                    fill="#845ADF"
                  />
                </svg>
              </ListGroup.Item> */}
            </ListGroup>
          </div>
        </Row>
      </Container>
    </section>
  );
};

export default observer(SubHeader);
